module.exports = __webpack_public_path__ + "static/media/AbyssinicaSIL-Regular.a7947fd4.woff";